import React, { useCallback } from 'react'
import * as Layout from 'views/layouts/MainLayout/MainLayout'
import * as Header from 'views/ui/Header/Header'
import { AddButton, SearchInput, useAction, useHelmet } from '@agro-club/frontend-shared'
import UserList from './UserList/UserList'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import Routes from './routes'
import UserActions from 'modules/domain/user/duck'
import UserSelectors from 'modules/domain/user/selectors'
import { useSelector } from 'react-redux'

const SearchInputWrapper = styled.div`
  margin-top: 14px;
  margin-bottom: 4px;
  width: 50%;
`

const UserTable = () => {
  const filter = useSelector(UserSelectors.filter)
  const filterUpdated = useAction(UserActions.filterUpdated)
  const { t } = useTranslation('user')

  const handleSearchChange = useCallback(
    (search?: string) => {
      filterUpdated({ ...filter, ...{ search } })
    },
    [filterUpdated, filter],
  )

  useHelmet({ title: t('usersMetaTitle') })

  return (
    <>
      <Layout.Header>
        <Header.Root>
          <Header.Title title={t('list.heading')}>
            <AddButton to={Routes.Add} />
          </Header.Title>
          <SearchInputWrapper>
            <SearchInput
              onChange={handleSearchChange}
              value={filter.search}
              placeholder={t('list.searchPlaceholder')}
            />
          </SearchInputWrapper>
        </Header.Root>
      </Layout.Header>
      <Layout.Content>
        <UserList />
      </Layout.Content>
    </>
  )
}

export default UserTable
